import { mergeStyles } from '@fluentui/react';

// Not importing from CommonStyleObjects because this style is specific to the process milestone
// action wrapper and has custom layout requirements (centered text, max-width, margin) that are
// not reusable across other components.
const milestoneListItemActionWrapper = mergeStyles({
  textAlign: 'center',
  maxWidth: 700,
  marginBottom: 20,
});

export default milestoneListItemActionWrapper;
